module.exports = __webpack_public_path__ + "media/images/lb/416-965b2452b8a78917fa5bf864e3acb8a8.svg";